@if (offer !== null) {
  <bp-modal-header [title]="headerTitle">
    <a right (click)="close()" (keydown.enter)="close()" [tabIndex]="0">
      {{ "abort" | translate }}
    </a>
  </bp-modal-header>
  <div class="bp-modal-body">
    @if (!showLoadingSpinner()) {
      <div
				[ngClass]="{
					'bp-modal-body-section mod-wide pt-25 pb-0': accepted
				}">
        <div class="bp-modal-body-section mod-wide pt-25 pb-0" [ngClass]="{ 'mod-transparent': accepted }">
          <div class="bp-modal-description">{{ "summary_sub_header" | translate }}</div>
          <div class="summary-grid">
            <summary-grid
              step="1"
              titleKey="summary_container_one_withdraw"
              class="summary-grid-item"
              [cssHover]="!accepted"
              (onStepClick)="setEdit($event)">
              <ng-container iconContainer>
                <div class="summary-card__currency-symbol mb-10">
                  <img
                    [src]="fiat?.getLogo()"
                    [style.width.px]="42"
                    (error)="img.src = fiat?.getDefaultLogo()"
                    alt="{{ 'logo_alt_text' | translate }}"
                    #img />
                </div>
              </ng-container>
              <ng-container detailsContainer>
                <span class="summary-card__text">{{ fiat?.getName() }} {{ "wallet" | translate }}</span>
              </ng-container>
            </summary-grid>
            <summary-grid
              step="2"
							titleKey="{{
								sendEnabled() ? 'summary_container_two_send' : 'summary_container_two_withdraw'
							}}"
              class="summary-grid-item"
              [cssHover]="!accepted"
              (onStepClick)="setEdit($event)">
              <ng-container iconContainer>
                @if (!sendEnabled()) {
                  <img
                    class="summary-card__image mb-10"
                    [src]="getLogoProvider()"
                    [alt]="getProviderShortName()" />
                }
                @if (sendEnabled()) {
                  <img
                    class="summary-card__image payments-sepa mb-10"
                    [src]="'assets/images/svg/Provider/Sepa.svg'"
                    [alt]="'sepa_image_alt_text' | translate" />
                }
              </ng-container>
              <ng-container detailsContainer>
                @if (!sendEnabled()) {
                  @for (f of fields; track f) {
                    <span
                      class="summary-card__text__block text-full-word-break"
                      >
                      @if (f?.getName() === 'iban') {
                        <span class="xsmall">
                          {{ formatIban(f?.getValue()) }}
                        </span>
                      }
                      @if (f?.getName() !== 'iban') {
                        <span class="small">{{ f?.getValue() }}</span>
                      }
                    </span>
                  }
                  @if (isProviderAmazon()) {
                    <span class="summary-card__text">
                      {{ getProviderShortName() }}
                    </span>
                  }
                } @else {
                  @for (f of fields; track f) {
                    <span
                      class="summary-card__text__block text-full-word-break"
                      >
                      @switch (f.getName()) {
                        @case ('payout_receiver_name') {
                          <span class="small">{{ f?.getValue() }}</span>
                        }
                        @case ('iban') {
                          <span class="small">{{ formatIban(f?.getValue()) }}</span>
                        }
                        @case ('bic') {
                          <span class="xsmall-payments"
                            >{{ "send_fiat_summary_bic" | translate }} {{ f?.getValue() }}</span
                            >
                          }
                          @default {
                            <span class="xsmall-payments">{{ f?.getValue() }}</span>
                          }
                        }
                      </span>
                    }
                    <span class="summary-card__text__block">
                      <span class="xsmall-payments">
                        {{ "send_fiat_payment_ref" | translate }}:
                        {{ offer?.getPaymentReference() }}
                      </span>
                    </span>
                  }
                </ng-container>
              </summary-grid>
              <summary-grid
                step="3"
                titleKey="amount_summary_withdraw"
                class="summary-grid-item"
                [cssHover]="!accepted"
                (onStepClick)="setEdit($event)">
                <ng-container detailsContainer>
                  <div class="text-big-black mb-10">
                    <strong>
                      {{
                      offer.total
                      | fiat_precision_symbol: { id: fiat?.getId(), currencies: [fiat] }
                      }}
                    </strong>
                  </div>
                  @if (!sendEnabled()) {
                    <div class="text-small-black">
                      {{ "inkl" | translate }}
                      <strong>
                        {{
                        offer?.getFee()
                        | fiat_precision_symbol
                        : { id: fiat?.getId(), currencies: [fiat, tradable] }
                        }}
                      </strong>
                      <br />
                      {{ "fee_transaction" | translate }}
                    </div>
                  }
                  @if (sendEnabled()) {
                    <div class="text-small-black">{{ "send_fiat_order_date" | translate }}</div>
                    <div class="text-small-black">{{ getCurrentDate() }}</div>
                    <div class="text-small-black mt-20">{{ "send_fiat_free_fees" | translate }}</div>
                  }
                </ng-container>
              </summary-grid>
            </div>
            @if (isVopFlagEnabled && (sendEnabled() || isBankTransfer)) {
              <div [class]="mappedPayeeResult().class + '-match-container mt-25 padding-15'">
                <p [class]="mappedPayeeResult().class + '-match-title'">{{
                  mappedPayeeResult().title | translate
                }}</p>
                <p
                  [class]="mappedPayeeResult().class + '-match-description mb-15'"
                  [innerHTML]="mappedPayeeResult().description | translate: [verifyPayeeAccountHolder()]">
                </p>
                @if (mappedPayeeResult().linkAction) {
                  <a (click)="payeeAction.emit()" class="action">{{
                    mappedPayeeResult().linkAction | translate
                  }}</a>
                }
              </div>
              <div class="terms pt-15 pl-15 pr-15 mt-25 mb-25">
                <bp-switch
                  class="m-0"
                  [model]="summarySwitch"
                  field="user_confirm"
                  [disabled]="isTermsSwitchDisabled()">
                  <span left>{{ mappedPayeeResult().terms | translate }}</span>
                </bp-switch>
              </div>
            } @else {
              <!-- Payments extra terms switchers #payments -->
              @if (sendEnabled() && (!needs2fa || (needs2fa && !accepted))) {
                <!-- Terms & conditions slider -->
                <div class="bp-modal-body-upper pt-0 mb-0">
                  <bp-switch [model]="summarySwitch" field="term_policy" [mb]="10">
                    <div left class="text-small-black">
                      {{ "send_fiat_summary_first_term" | translate }}
                      <a [href]="getPaymentsTermsLink()" [target]="'_blank'">
                        {{ "send_fiat_summary_first_term_conditions" | translate }}
                      </a>
                      {{ "send_fiat_summary_first_links_separator" | translate }}
                      <a [href]="getPaymentsPolicyLink()" [target]="'_blank'">
                        {{ "send_fiat_summary_first_term_policy" | translate }}
                      </a>
                    </div>
                  </bp-switch>
                </div>
                <hr class="mb-10 mt-10" />
                <!-- User's own will slider -->
                <div class="bp-modal-body-upper pt-0 mb-0">
                  <bp-switch [model]="summarySwitch" field="user_confirm" [mb]="10">
                    <div left class="text-small-black">{{
                      "send_fiat_summary_second_term" | translate
                    }}</div>
                  </bp-switch>
                </div>
              }
            }
          </div>
        </div>
        <span class="bp-modal-body-2fa" style="align-content: center">
          @if (accepted) {
            <two-fa (save)="save($event)" type="fiat_withdraw"></two-fa>
          }
        </span>
        <!--
        *
        *
        *   BOTTOM
        *
        *
        -->
        @if (!needs2fa) {
          <div style="text-align: center">
            <loading-button
              styles="btn btn-primary btn-lg btn-summary mod-send {{ disabledConfirmButton ? 'disabled' : '' }}"
              [disabled]="disabledConfirmButton"
              [text]="'summary_button_confirm' | translate"
              [throttleTime]="4000"
              (onClick)="onConfirmButtonClick()">
            </loading-button>
          </div>
        }
        @if (needs2fa) {
          <div style="text-align: center">
            @if (!accepted) {
              <loading-button
                styles="btn btn-primary btn-lg btn-summary mod-send {{ disabledConfirmButton ? 'disabled' : '' }}"
                [disabled]="disabledConfirmButton"
                [text]="'summary_button_confirm' | translate"
                [throttleTime]="4000"
                (onClick)="onConfirmButtonClick()">
              </loading-button>
            }
          </div>
        }
        @if (needs2fa && accepted) {
          <div class="bp-modal-body-2fa-empty text-center"></div>
        }
      } @else {
        <div class="bp-modal-body loading">
          <loading-spinner></loading-spinner>
        </div>
      }
    </div>
  }
